import React from 'react';

import { PrimaryButton as RexlabsButton } from '@rexlabs/button';

function PrimaryButton(props) {
  return <RexlabsButton {...props} />;
}

export default PrimaryButton;
